/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content1/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Content1({
  children,
  viewPath = "/DesignSystem/BrandLogo/Content",
  width,
  height
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let logoFileIdValueData = fromData.useDataValue({ viewPath,
context: 'logo',
path: 'file_id',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(logoFileIdValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
 width={width}
 height={height}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
 width={width}
 height={height}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}